var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c("div", { staticClass: "modal-dialog modal-lg" }, [
    _c("div", { staticClass: "modal-content" }, [
      _c("div", { staticClass: "modal-header" }, [
        _c("h4", { staticClass: "modal-title" }, [_vm._v("Order Logs")]),
        _vm._v(" "),
        _c("button", {
          staticClass: "btn-close",
          attrs: { type: "button", "aria-label": "Close" },
          on: {
            click: function ($event) {
              return _vm.$emit("hide-modal")
            },
          },
        }),
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "modal-body" }, [
        _setup.loading
          ? _c("div", { staticClass: "text-center p-5" }, [
              _c("div", {
                staticClass: "spinner-border text-primary",
                attrs: { role: "status" },
              }),
              _vm._v(" "),
              _c("p", { staticClass: "mt-2 text-muted" }, [
                _vm._v("Loading logs..."),
              ]),
            ])
          : _setup.logs.length === 0
          ? _c("div", { staticClass: "text-center p-5" }, [
              _c("p", { staticClass: "text-muted" }, [
                _vm._v("No logs found for this order."),
              ]),
            ])
          : _c(
              "div",
              { staticClass: "list-group" },
              _vm._l(_setup.logs, function (log, index) {
                return _c(
                  "div",
                  { key: log.id || index, staticClass: "list-group-item pb-0" },
                  [
                    _c(
                      "div",
                      {
                        staticClass: "py-2",
                        staticStyle: { cursor: "pointer" },
                        attrs: {
                          "data-bs-target": "#log-" + index,
                          "data-bs-toggle": "collapse",
                        },
                      },
                      [
                        _c(
                          "span",
                          { staticClass: "float-end text-muted small" },
                          [
                            _vm._v(
                              "\n                            " +
                                _vm._s(_setup.formatDate(log.createdDate)) +
                                "\n                        "
                            ),
                          ]
                        ),
                        _vm._v(" "),
                        _c("p", { staticClass: "mb-0" }, [
                          _c("i", { staticClass: "bi bi-journal-text me-2" }),
                          _vm._v(" "),
                          _c("strong", [_vm._v(_vm._s(log.title))]),
                        ]),
                      ]
                    ),
                    _vm._v(" "),
                    _c(
                      "div",
                      {
                        staticClass: "collapse mt-2",
                        attrs: { id: "log-" + index },
                      },
                      [
                        _c(
                          "div",
                          { staticClass: "bg-light p-3 border rounded mb-3" },
                          [
                            _c("pre", { staticClass: "log-pre mb-0" }, [
                              _c("code", [_vm._v(_vm._s(log.data))]),
                            ]),
                          ]
                        ),
                      ]
                    ),
                  ]
                )
              }),
              0
            ),
      ]),
    ]),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }